var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bottom-info" }, [
      _c("div", [_c("span", [_vm._v("后台管理系统")])])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }